(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gf-globals"] && !Shopify.designMode) return;
  try {
    (() => {
  const configNode = document.getElementById('GFConfig');
  if (!configNode || window.gfInitialized) return;
  window.gfInitialized = true;
  const cfg = JSON.parse(configNode.textContent);
  const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en-IN', {style:'currency', currency:cfg.currency}).format(Number(value) / 100);
  const root = cfg.root.endsWith('/') ? cfg.root : `${cfg.root}/`;
  const recentKey = 'glowfinch_recent_v1';
  const recentLimit = 12;
  let recentMemory = [];
  let recentStorageFailed = false;
  let recentInstance = 0;
  const recentCards = new Map();
  const normaliseRecent = values => Array.isArray(values) ? [...new Set(values.filter(value => typeof value === 'string' && value.length <= 255 && /^[a-z0-9][a-z0-9-]*$/.test(value)))].slice(0, recentLimit) : [];
  const getRecent = () => {
    if (recentStorageFailed) return [...recentMemory];
    try { recentMemory = normaliseRecent(JSON.parse(localStorage.getItem(recentKey) || '[]')); } catch { recentStorageFailed = true; }
    return [...recentMemory];
  };
  const writeRecent = values => {
    recentMemory = normaliseRecent(values);
    let persisted = true;
    try { localStorage.setItem(recentKey, JSON.stringify(recentMemory)); recentStorageFailed = false; } catch { persisted = false; recentStorageFailed = true; }
    document.dispatchEvent(new CustomEvent('gf:recent-changed'));
    return persisted;
  };
  const recordRecent = handle => {
    if (normaliseRecent([handle]).length) writeRecent([handle, ...getRecent().filter(value => value !== handle)]);
  };
  window.addEventListener('storage', event => {
    if (event.key === recentKey || event.key === null) { recentStorageFailed = false; document.dispatchEvent(new CustomEvent('gf:recent-changed')); }
  });
  window.addEventListener('pageshow', event => {
    if (!event.persisted) return;
    recentCards.clear();
    const product = document.querySelector('gf-product[data-product-handle]');
    if (product) recordRecent(product.dataset.productHandle);
    else document.dispatchEvent(new CustomEvent('gf:recent-changed'));
  });
  const fetchRecentCard = handle => {
    if (!recentCards.has(handle)) {
      const request = (async () => {
        const response = await fetch(`${root}products/${encodeURIComponent(handle)}?section_id=gf-recent-card`, {credentials: 'same-origin'});
        if (response.status === 404 || response.status === 410) return null;
        if (!response.ok) throw new Error('Recent product could not load');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const card = doc.querySelector('[data-gf-recent-payload]');
        if (!card || card.dataset.handle !== handle) throw new Error('Recent product response did not match');
        return card;
      })();
      recentCards.set(handle, request);
      request.catch(() => recentCards.delete(handle));
    }
    return recentCards.get(handle);
  };

  let toastTimer;
  const toast = message => {const node=document.getElementById('GFToast');if(!node)return;node.textContent=message;node.hidden=false;clearTimeout(toastTimer);toastTimer=setTimeout(()=>node.hidden=true,5500);};
  document.addEventListener('gf:notice',event=>{if(typeof event.detail==='string')toast(event.detail);});
  const cartCount = count => document.querySelectorAll('[data-gf-cart-count]').forEach(el=>el.textContent=count);
  const jsonFetch = async (url,options={}) => {const response=await fetch(url,{credentials:'same-origin',...options});let data;try{data=await response.json();}catch{throw new Error(cfg.error);}if(!response.ok)throw new Error(typeof data.description==='string'?data.description:cfg.error);return data;};
  const dialog=document.getElementById('GFCartDialog');
  if(dialog){dialog.addEventListener('click',event=>{if(event.target===dialog||event.target.closest('[data-gf-dialog-close]'))dialog.close();});}
  document.addEventListener('click',async event=>{
    const button=event.target.closest('[data-gf-copy-code]');
    if(!button)return;
    const code=button.dataset.gfCopyCode;
    try{
      await navigator.clipboard.writeText(code);
      const label=button.querySelector('[data-gf-copy-label]');
      if(label){label.textContent=cfg.coupon.copied;clearTimeout(button.gfCopyTimer);button.gfCopyTimer=setTimeout(()=>label.textContent=cfg.coupon.copy,2000);}
      toast(cfg.coupon.copy_success.replace('[code]',code));
    }catch{
      const node=button.querySelector('.gf-coupon-code');
      if(node){const range=document.createRange();range.selectNodeContents(node);const selection=window.getSelection();selection.removeAllRanges();selection.addRange(range);}
      toast(cfg.coupon.copy_fallback.replace('[code]',code));
    }
  });
  class GFCartCoupon extends HTMLElement {
    connectedCallback(){
      if(this.ready)return;this.ready=true;
      this.input=this.querySelector('[data-gf-coupon-input]');
      this.addEventListener('click',event=>{
        if(event.target.closest('[data-gf-coupon-apply]'))this.update();
        const remove=event.target.closest('[data-gf-coupon-remove]');
        if(remove)this.update(remove.dataset.gfCouponRemove);
      });
      this.input.addEventListener('keydown',event=>{if(event.key==='Enter'){event.preventDefault();this.update();}});
    }
    status(message,invalid=false){
      const node=this.querySelector('[data-gf-coupon-status]');
      node.textContent=message;node.dataset.error=String(invalid);
      this.input.setAttribute('aria-invalid',String(invalid));
    }
    async update(removeCode){
      if(this.busy)return;
      const code=this.input.value.trim();
      if(removeCode===undefined&&!code){this.status(cfg.coupon.required,true);this.input.focus();return;}
      const form=this.closest('form');
      const existing=[...this.querySelectorAll('[data-gf-existing-code]')].map(el=>el.dataset.gfExistingCode);
      const codes=removeCode===undefined?[...existing.filter(value=>value.toLowerCase()!==code.toLowerCase()),code]:existing.filter(value=>value!==removeCode);
      const controls=[...form.querySelectorAll('button,input,select')];
      const wasDisabled=controls.map(el=>el.disabled);
      this.busy=true;this.setAttribute('aria-busy','true');controls.forEach(el=>el.disabled=true);
      this.status(cfg.coupon.applying);
      const sectionId=this.dataset.sectionId;
      let changed=false;
      try{
        const cart=await jsonFetch(`${root}cart/update.js`,{
          method:'POST',headers:{'Content-Type':'application/json'},
          body:JSON.stringify({discount:codes.join(','),sections:[sectionId],sections_url:`${root}cart`})
        });
        changed=true;cartCount(cart.item_count);
        const applications=[...(cart.cart_level_discount_applications||[]),...(cart.items||[]).flatMap(item=>(item.line_level_discount_allocations||[]).map(allocation=>allocation.discount_application))];
        const applied=applications.some(application=>application.type==='discount_code'&&application.title?.toLowerCase()===code.toLowerCase())||(cart.discount_codes||[]).some(discount=>discount.code?.toLowerCase()===code.toLowerCase()&&discount.applicable===true);
        let html=cart.sections?.[sectionId];
        if(!html){const response=await fetch(`${root}cart?section_id=${encodeURIComponent(sectionId)}`,{credentials:'same-origin',cache:'no-store'});if(response.ok)html=await response.text();}
        const nextForm=new DOMParser().parseFromString(html||'','text/html').querySelector('.gf-cart-form');
        if(!nextForm)throw new Error(cfg.error);
        form.replaceWith(nextForm);
        const component=nextForm.querySelector('gf-cart-coupon');
        const message=removeCode!==undefined?cfg.coupon.removed:applied?cfg.coupon.applied.replace('[code]',code):cfg.coupon.unavailable;
        if(component){
          component.status(message,removeCode===undefined&&!applied);
          if(!applied&&removeCode===undefined)component.input.value=code;
          component.querySelector('[data-gf-coupon-status]').focus({preventScroll:true});
        }
      }catch(error){
        if(changed){location.assign(`${root}cart`);return;}
        this.status(error.message||cfg.error,true);
      }finally{
        this.busy=false;this.removeAttribute('aria-busy');
        controls.forEach((el,index)=>el.disabled=wasDisabled[index]);
      }
    }
  }
  document.addEventListener('submit',async event=>{
    const form=event.target;
    if(!(form instanceof HTMLFormElement)||!form.matches('[data-gf-add]'))return;
    event.preventDefault();
    if(form.dataset.gfBusy==='true')return;
    form.dataset.gfBusy='true';
    const buttons=[...form.querySelectorAll('[type=submit]'),...document.querySelectorAll(`button[form="${CSS.escape(form.id)}"]`)];
    const previous=buttons.map(button=>button.disabled);
    buttons.forEach(button=>{button.disabled=true;button.setAttribute('aria-busy','true');});
    const errorNode=form.querySelector('[data-gf-error]');if(errorNode)errorNode.hidden=true;
    let added=false;
    try{
      const data=new FormData(form);data.delete('return_to');data.delete('form_type');data.delete('utf8');
      await jsonFetch(`${root}cart/add.js`,{method:'POST',body:data});added=true;
      const cart=await jsonFetch(`${root}cart.js`);cartCount(cart.item_count);
      const response=await fetch(`${root}cart?section_id=gf-cart-summary`,{credentials:'same-origin'});
      if(!response.ok)throw new Error(cfg.error);
      const html=await response.text();const parsed=new DOMParser().parseFromString(html,'text/html');const content=parsed.querySelector('.gf-cart-drawer-content');
      if(content&&dialog){dialog.querySelector('[data-gf-cart-content]').replaceChildren(content);if(!dialog.open)dialog.showModal();}else toast(cfg.added);
    }catch(error){const message=added?cfg.added:`${error.message || cfg.error}`;if(errorNode&&!added){errorNode.textContent=message;errorNode.hidden=false;}toast(message);}
    finally{delete form.dataset.gfBusy;buttons.forEach((button,i)=>{button.disabled=previous[i];button.removeAttribute('aria-busy');});}
  });
  window.addEventListener('pageshow',event=>{if(event.persisted)jsonFetch(`${root}cart.js`).then(cart=>cartCount(cart.item_count)).catch(()=>{});});
  class GFCountdown extends HTMLElement{
    connectedCallback(){if(this.timer)return;const tick=()=>{const day=86400000;const now=Date.now()+19800000;let remaining=Math.ceil((day-((now%day+day)%day))/1000);const h=Math.floor(remaining/3600);remaining%=3600;const m=Math.floor(remaining/60),s=remaining%60;[['hours',h],['minutes',m],['seconds',s]].forEach(([name,value])=>{const cell=this.querySelector(`[data-${name}]`);if(cell)cell.textContent=String(value).padStart(2,'0');});};tick();this.timer=setInterval(tick,1000);}
    disconnectedCallback(){clearInterval(this.timer);this.timer=null;}
  }
  class GFProduct extends HTMLElement{
    connectedCallback(){if(this.ready)return;this.ready=true;this.variants=JSON.parse(this.querySelector('[data-gf-variants]').textContent);this.form=this.querySelector('.gf-product-form');this.variantField=this.form.elements.id;this.quantity=this.form.elements.quantity;this.offer=this.dataset.quantityOffer==='true';
      this.addEventListener('click',event=>{const imageButton=event.target.closest('[data-gf-image]');if(imageButton){this.setImage(imageButton.dataset.gfImage,imageButton.dataset.gfImageAlt);this.querySelectorAll('[data-gf-image]').forEach(button=>button.setAttribute('aria-pressed',button===imageButton?'true':'false'));}
        const tier=event.target.closest('[data-gf-tier]');if(tier){this.quantity.value=tier.dataset.gfTier;this.updateQuantity();}
        const step=event.target.closest('[data-gf-step]');if(step){const increment=Number(this.quantity.step)||1;const value=Number(this.quantity.value)||Number(this.quantity.min)||1;this.quantity.value=value+Number(step.dataset.gfStep)*increment;this.updateQuantity();}
      });
      this.variantField.addEventListener('change',()=>this.updateVariant(true));this.quantity.addEventListener('change',()=>this.updateQuantity());this.updateVariant(false);
      recordRecent(this.dataset.productHandle);
    }
    setImage(url,alt){const image=this.querySelector('[data-gf-main-image]');if(image&&url){image.src=url;image.removeAttribute('srcset');image.alt=alt||image.alt;}}
    updateVariant(changeUrl){this.variant=this.variants.find(v=>String(v.id)===this.variantField.value)||this.variants[0];const v=this.variant;if(!v)return;const wish=this.querySelector('[data-gf-product-wishlist] [data-gf-wishlist-toggle]');if(wish)wish.dataset.variantId=String(v.id);this.querySelectorAll('[data-gf-price],[data-gf-sticky-price],[data-gf-mobile-price]').forEach(el=>el.textContent=money(v.price));const compare=this.querySelector('[data-gf-compare]');compare.hidden=!(v.compare>v.price);compare.textContent=money(v.compare);const sale=this.querySelector('[data-gf-sale]');sale.hidden=!(v.compare>v.price);sale.textContent=cfg.off.replace('[percent]',String(Math.round((v.compare-v.price)*100/v.compare)));const save=this.querySelector('[data-gf-save]');save.textContent=v.compare>v.price?cfg.save.replace('[amount]',money(v.compare-v.price)):'';this.querySelectorAll('[data-gf-product-submit]').forEach(button=>{button.disabled=!v.available;button.textContent=v.available?cfg.add:cfg.soldOut;});const sku=this.querySelector('[data-gf-sku]');if(sku)sku.textContent=v.sku||'';this.quantity.min=v.min||1;this.quantity.step=v.step||1;let max=v.max;if(v.limited)max=max==null?v.inventory:Math.min(max,v.inventory);if(max!=null&&max>0)this.quantity.max=max;else this.quantity.removeAttribute('max');if(changeUrl){const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState({},'',url);if(v.image)this.setImage(v.image);}this.querySelectorAll('[data-gf-tier]').forEach(button=>button.disabled=!v.available||(max!=null&&max<Number(button.dataset.gfTier)));this.querySelectorAll('[data-gf-tier-price]').forEach(el=>{const count=Number(el.dataset.gfTierPrice);el.textContent=money(v.price*count*(count>=3?.8:.9));});this.updateQuantity();}
    updateQuantity(){const min=Number(this.quantity.min)||1;const step=Number(this.quantity.step)||1;let value=Math.max(min,Math.round(Number(this.quantity.value)||min));value=min+Math.round((value-min)/step)*step;const max=this.quantity.max?Number(this.quantity.max):Infinity;value=Math.min(value,max);this.quantity.value=value;this.querySelectorAll('[data-gf-tier]').forEach(button=>button.setAttribute('aria-pressed',(Number(button.dataset.gfTier)===2?value===2:value>=3)?'true':'false'));const discount=this.offer?(value>=3?.2:value>=2?.1:0):0;this.querySelector('[data-gf-estimate]').textContent=money(Math.round(this.variant.price*value*(1-discount)));}
  }
  class GFRecent extends HTMLElement {
    connectedCallback() {
      if (!this.ready) {
        this.ready = true;
        this.scope = `GFRecent-${++recentInstance}`;
        this.list = this.querySelector('[data-gf-recent-list]');
        this.empty = this.querySelector('[data-gf-recent-empty]');
        this.loading = this.querySelector('[data-gf-recent-loading]');
        this.error = this.querySelector('[data-gf-recent-error]');
        this.toolbar = this.querySelector('[data-gf-recent-toolbar]');
        this.shell = this.closest('[data-gf-recent-shell]') || this;
        this.onHistory = () => this.renderHistory();
        this.addEventListener('click', event => {
          if (event.target.closest('[data-gf-recent-clear]')) {
            const persisted = writeRecent([]);
            this.querySelectorAll('details[open]').forEach(details => details.open = false);
            document.dispatchEvent(new CustomEvent('gf:notice', {detail: persisted ? cfg.recent.cleared : cfg.recent.clear_session}));
          }
          if (event.target.closest('[data-gf-recent-retry]')) this.renderHistory();
        });
      }
      if (!this.list) return;
      document.addEventListener('gf:recent-changed', this.onHistory);
      this.inView = this.dataset.lazy !== 'true' || !('IntersectionObserver' in window);
      if (!this.inView) {
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) {
            this.inView = true;
            this.observer.disconnect();
            this.renderHistory();
          }
        }, {rootMargin: '350px'});
        this.observer.observe(this);
      }
      this.renderHistory();
    }
    disconnectedCallback() {
      document.removeEventListener('gf:recent-changed', this.onHistory);
      this.observer?.disconnect();
      this.revision = (this.revision || 0) + 1;
    }
    async renderHistory() {
      if (!this.list || !this.isConnected) return;
      const revision = this.revision = (this.revision || 0) + 1;
      const limit = Math.min(recentLimit, Math.max(1, Number(this.dataset.limit) || 4));
      const handles = getRecent().filter(handle => handle !== this.dataset.current).slice(0, limit);
      this.list.replaceChildren();
      if (this.error) this.error.hidden = true;
      if (this.loading) this.loading.hidden = !handles.length;
      if (this.empty) this.empty.hidden = !!handles.length;
      if (this.toolbar) this.toolbar.hidden = !handles.length;
      const hideEmpty = this.dataset.hideEmpty === 'true' && this.dataset.editor !== 'true';
      this.shell.hidden = hideEmpty && !handles.length;
      if (!handles.length || !this.inView) { this.removeAttribute('aria-busy'); return; }
      this.setAttribute('aria-busy', 'true');
      let failures = 0;
      const cards = [];
      for (let offset = 0; offset < handles.length; offset += 4) {
        const results = await Promise.allSettled(handles.slice(offset, offset + 4).map(fetchRecentCard));
        if (!this.isConnected || this.revision !== revision) return;
        for (const result of results) {
          if (result.status !== 'fulfilled') { failures++; continue; }
          if (!result.value) continue;
          const source = result.value.querySelector(this.dataset.layout === 'grid' ? '[data-gf-recent-full] .gf-product-card' : '[data-gf-recent-mini]');
          if (!source) { failures++; continue; }
          const card = source.cloneNode(true);
          card.querySelectorAll('form[id]').forEach(form => form.id += `-${this.scope}`);
          cards.push(card);
        }
      }
      this.list.replaceChildren(...cards);
      if (this.loading) this.loading.hidden = true;
      if (this.empty) this.empty.hidden = cards.length > 0 || failures > 0;
      if (this.error) this.error.hidden = failures === 0;
      this.shell.hidden = hideEmpty && cards.length === 0 && failures === 0;
      this.removeAttribute('aria-busy');
    }
  }
  class GFRecommendations extends HTMLElement{
    connectedCallback(){if(this.loaded||!this.dataset.url)return;this.loaded=true;this.observer=new IntersectionObserver(entries=>{if(entries.some(entry=>entry.isIntersecting)){this.observer.disconnect();fetch(this.dataset.url,{credentials:'same-origin'}).then(response=>response.ok?response.text():'').then(html=>{const doc=new DOMParser().parseFromString(html,'text/html');const content=doc.querySelector('gf-recommendations');if(this.isConnected&&content?.querySelector('.gf-product-card'))this.innerHTML=content.innerHTML;}).catch(()=>{});}}, {rootMargin:'250px'});this.observer.observe(this);}
    disconnectedCallback(){this.observer?.disconnect();}
  }
  [['gf-cart-coupon',GFCartCoupon],['gf-countdown',GFCountdown],['gf-product',GFProduct],['gf-recent',GFRecent],['gf-recommendations',GFRecommendations]].forEach(([name,constructor])=>{if(!customElements.get(name))customElements.define(name,constructor);});
})();
(() => {
  const node=document.getElementById('GFConfig');
  if(!node||window.gfWishlistInitialized)return;
  const cfg=JSON.parse(node.textContent);
  if(!cfg.wishlistEnabled)return;
  window.gfWishlistInitialized=true;
  const words=cfg.wishlist;
  const root=cfg.root.endsWith('/')?cfg.root:`${cfg.root}/`;
  const key='glowfinch_wishlist_v1';
  const itemKey=item=>`${item.handle}:${item.variantId}`;
  const clean=value=>{
    if(!Array.isArray(value))return [];
    const seen=new Set();
    return value.filter(item=>{
      if(!item||typeof item.handle!=='string'||!/^[-a-z0-9]+$/.test(item.handle)||!/^\d{6,20}$/.test(String(item.variantId)))return false;
      const id=itemKey(item);if(seen.has(id))return false;seen.add(id);return true;
    }).slice(0,100).map(item=>({handle:item.handle,variantId:String(item.variantId),title:typeof item.title==='string'?item.title.slice(0,500):words.item,savedAt:Number.isFinite(item.savedAt)?item.savedAt:0}));
  };
  let memory=[],lastRemoved=[],persistent=true;
  const read=()=>{try{return clean(JSON.parse(localStorage.getItem(key)||'[]'));}catch{persistent=false;return memory;}};
  memory=read();
  const announce=message=>document.dispatchEvent(new CustomEvent('gf:notice',{detail:message}));
  const matches=(a,b)=>itemKey(a)===itemKey(b);
  const fromButton=button=>({handle:button.dataset.handle,variantId:button.dataset.variantId,title:button.dataset.productTitle||words.item,savedAt:Date.now()});
  const sync=()=>{
    const items=persistent?read():memory;
    document.querySelectorAll('[data-gf-wishlist-toggle]').forEach(button=>{
      const saved=items.some(item=>matches(item,fromButton(button)));
      if(button.getAttribute('aria-pressed')!==String(saved))button.setAttribute('aria-pressed',String(saved));
      const label=(saved?words.remove_product:words.save_product).replace('[title]',button.dataset.productTitle||words.item);
      if(button.getAttribute('aria-label')!==label)button.setAttribute('aria-label',label);
      const text=button.querySelector('[data-gf-wishlist-label]');
      if(text&&text.textContent!==(saved?words.saved:words.save))text.textContent=saved?words.saved:words.save;
    });
    document.querySelectorAll('[data-gf-wishlist-count]').forEach(el=>{if(el.textContent!==String(items.length))el.textContent=items.length;el.hidden=items.length===0;});
    document.querySelectorAll('[data-gf-wishlist-link]').forEach(link=>link.setAttribute('aria-label',words.link_count.replace('[count]',items.length)));
    document.querySelectorAll('[data-gf-wishlist-undo]').forEach(button=>button.hidden=lastRemoved.length===0);
  };
  const commit=(items,message)=>{
    memory=clean(items);
    try{localStorage.setItem(key,JSON.stringify(memory));persistent=true;}catch{persistent=false;}
    sync();document.dispatchEvent(new CustomEvent('gf:wishlist:change'));
    announce(persistent?message:words.session_only);
  };
  const remove=item=>{
    const items=persistent?read():memory;
    lastRemoved=items.filter(saved=>matches(saved,item));
    commit(items.filter(saved=>!matches(saved,item)),words.removed);
  };
  document.addEventListener('click',event=>{
    const toggle=event.target.closest('[data-gf-wishlist-toggle]');
    if(toggle){
      event.preventDefault();const item=fromButton(toggle);if(clean([item]).length===0)return;
      const items=persistent?read():memory;
      if(items.some(saved=>matches(saved,item)))remove(item);
      else if(items.length>=100)announce(words.limit);
      else commit([item,...items],words.added);
    }
    const removeButton=event.target.closest('[data-gf-wishlist-remove]');
    if(removeButton){event.preventDefault();remove(fromButton(removeButton));}
    const clearButton=event.target.closest('[data-gf-wishlist-clear]');
    if(clearButton){lastRemoved=persistent?read():memory;clearButton.closest('details').open=false;commit([],words.cleared);}
    if(event.target.closest('[data-gf-wishlist-undo]')){
      const current=persistent?read():memory;const restored=[...current,...lastRemoved.filter(item=>!current.some(saved=>matches(saved,item)))];
      lastRemoved=[];commit(restored,words.restored);
    }
  });
  window.addEventListener('storage',event=>{if(event.key===key||event.key===null){memory=read();sync();document.dispatchEvent(new CustomEvent('gf:wishlist:change'));}});
  window.addEventListener('pageshow',event=>{if(event.persisted){memory=read();sync();document.dispatchEvent(new CustomEvent('gf:wishlist:change'));}});
  const cards=new Map();
  const loadCard=async item=>{
    const id=itemKey(item);
    if(!cards.has(id))cards.set(id,(async()=>{
      const response=await fetch(`${root}products/${encodeURIComponent(item.handle)}?variant=${encodeURIComponent(item.variantId)}&section_id=gf-wishlist-card`,{credentials:'same-origin',cache:'no-store'});
      if(!response.ok)throw new Error(words.unavailable);
      const html=await response.text();
      const card=new DOMParser().parseFromString(html,'text/html').querySelector('[data-gf-saved-card]');
      if(!card||card.dataset.variantId!==item.variantId)throw new Error(words.unavailable);
      return card.outerHTML;
    })().catch(error=>{cards.delete(id);throw error;}));
    const html=await cards.get(id);
    return new DOMParser().parseFromString(html,'text/html').querySelector('[data-gf-saved-card]');
  };
  class GFWishlist extends HTMLElement {
    connectedCallback(){
      if(this.ready)return;this.ready=true;this.limit=this.dataset.page==='true'?12:Number(this.dataset.limit)||4;
      this.refresh=()=>this.render();document.addEventListener('gf:wishlist:change',this.refresh);
      this.addEventListener('click',event=>{if(event.target.closest('[data-gf-wishlist-more]')){this.limit+=12;this.render();}if(event.target.closest('[data-gf-wishlist-retry]'))this.render();});
      this.render();
    }
    disconnectedCallback(){document.removeEventListener('gf:wishlist:change',this.refresh);this.revision=(this.revision||0)+1;this.ready=false;}
    unavailable(item){
      const card=document.createElement('article');card.className='gf-wishlist-unavailable';
      const title=document.createElement('h3');title.textContent=item.title;
      const text=document.createElement('p');text.textContent=words.unavailable;
      const retry=document.createElement('button');retry.type='button';retry.className='gf-button gf-button-outline gf-button-small';retry.dataset.gfWishlistRetry='';retry.textContent=words.retry;
      const removeButton=document.createElement('button');removeButton.type='button';removeButton.className='gf-wishlist-remove-link';removeButton.dataset.gfWishlistRemove='';removeButton.dataset.handle=item.handle;removeButton.dataset.variantId=item.variantId;removeButton.textContent=words.remove;
      card.append(title,text,retry,removeButton);return card;
    }
    async render(){
      const revision=this.revision=(this.revision||0)+1;
      const items=(persistent?read():memory).slice().sort((a,b)=>b.savedAt-a.savedAt);
      const shown=items.slice(0,this.limit);
      const grid=this.querySelector('[data-gf-wishlist-grid]');
      const restoreFocus=grid.contains(document.activeElement);
      grid.replaceChildren();grid.setAttribute('aria-busy',String(shown.length>0));
      this.querySelector('[data-gf-wishlist-empty]').hidden=items.length>0;
      this.querySelector('[data-gf-wishlist-toolbar]').hidden=items.length===0;
      this.querySelector('[data-gf-wishlist-summary]').textContent=words.showing.replace('[shown]',shown.length).replace('[total]',items.length);
      const loading=this.querySelector('[data-gf-wishlist-loading]');loading.hidden=shown.length===0;
      const more=this.querySelector('[data-gf-wishlist-more]');if(more){more.hidden=items.length<=this.limit;more.disabled=true;}
      sync();
      for(let index=0;index<shown.length;index+=4){
        const batch=shown.slice(index,index+4);
        const results=await Promise.allSettled(batch.map(loadCard));
        if(!this.isConnected||this.revision!==revision)return;
        results.forEach((result,i)=>grid.append(result.status==='fulfilled'?result.value:this.unavailable(batch[i])));
      }
      if(this.revision!==revision||!this.isConnected)return;
      grid.setAttribute('aria-busy','false');loading.hidden=true;if(more)more.disabled=false;sync();
      if(restoreFocus){const undo=this.querySelector('[data-gf-wishlist-undo]');if(!undo.hidden)undo.focus({preventScroll:true});}
    }
  }
  if(!customElements.get('gf-wishlist'))customElements.define('gf-wishlist',GFWishlist);
  let scheduled=false;
  new MutationObserver(()=>{if(!scheduled){scheduled=true;requestAnimationFrame(()=>{scheduled=false;sync();});}}).observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['data-variant-id']});
  sync();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gf-shiprocket"] && !Shopify.designMode) return;
  try {
    (() => {
  const boot = () => {
    if (window.gfShiprocketBridgeReady) return;
    window.gfShiprocketBridgeReady = true;
    const sync = () => {
      document.querySelectorAll('[data-gf-checkout-options]').forEach(container => {
        const slot = container.querySelector('.gf-shiprocket-slot');
        const ready = !!slot?.querySelector('.sr-headless-checkout, button, [role="button"]');
        const state = String(ready);
        if (container.dataset.srReady !== state) container.dataset.srReady = state;
        slot?.querySelectorAll('button').forEach(button => { if (button.type === 'submit') button.type = 'button'; });
        const label = container.querySelector('[data-gf-native-label]');
        const text = ready ? label?.dataset.readyLabel : label?.dataset.defaultLabel;
        if (label && label.textContent !== text) label.textContent = text;
      });
    };
    let queued = false;
    const schedule = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; sync(); });
    };
    new MutationObserver(schedule).observe(document.body, {childList:true, subtree:true});
    document.addEventListener('click', event => {
      if (!(event.target instanceof Element)) return;
      const trigger = event.target.closest('.sr-headless-checkout, button, [role="button"]');
      const container = trigger?.closest('[data-gf-checkout-options]');
      if (!container || !trigger.closest('.gf-shiprocket-slot') || trigger.disabled || trigger.getAttribute('aria-disabled') === 'true') return;
      const form = container.closest('form');
      const busy = !!form?.querySelector('gf-cart-coupon[aria-busy="true"]');
      const changedQuantity = [...(form?.querySelectorAll('[data-gf-cart-quantity]') || [])].some(input => Number(input.value) !== Number(input.dataset.gfCartQuantity));
      if (busy || changedQuantity) {
        event.preventDefault();
        event.stopImmediatePropagation();
        const error = container.querySelector('[data-gf-checkout-error]');
        error.textContent = busy ? container.dataset.gfBusyMessage : container.dataset.gfPendingMessage;
        error.hidden = false;
        if (!busy) form.querySelector('button[name="update"]')?.focus({preventScroll:true});
        return;
      }
      // Leave the provider's click intact, and release the native dialog's
      // top layer so its checkout overlay can receive focus.
      if (trigger instanceof HTMLButtonElement) trigger.type = 'button';
      const dialog = trigger.closest('dialog');
      if (dialog?.open) dialog.close();
    }, true);
    sync();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once:true});
  else boot();
})();
  } catch(e) { console.error(e); }
})();

})();
